export default __webpack_public_path__ + "static/media/icon-checked.3d7b9997.svg";